import { clientExperience, CLIENT_KIND } from "./clientExperience";
import {
  musicVendorExperience,
  MUSIC_VENDOR_KIND,
} from "./musicVendorExperience";
import {
  installerVendorExperience,
  INSTALLER_VENDOR_KIND,
} from "./installerVendorExperience";

const REGISTRY = Object.freeze({
  [CLIENT_KIND]: clientExperience,
  [MUSIC_VENDOR_KIND]: musicVendorExperience,
  [INSTALLER_VENDOR_KIND]: installerVendorExperience,
});

export const KNOWN_TENANT_KINDS = Object.freeze(Object.keys(REGISTRY));

export function getExperience(kind) {
  if (!kind || typeof kind !== "string") return null;
  return REGISTRY[kind] || null;
}

export function isKnownTenantKind(kind) {
  return Boolean(getExperience(kind));
}

export { CLIENT_KIND, MUSIC_VENDOR_KIND, INSTALLER_VENDOR_KIND };
